import React from 'react';
import { Box, Stack, Typography, Link } from '@mui/material'
import { styled, alpha } from '@mui/material/styles';
import { COLORS } from '../theme/colors';
const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    bottom: 0,
    zIndex: 1,
    justifyContent: 'space-between',
    flexShrink: 0,
    borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
    backdropFilter: 'blur(24px)',
    border: '1px solid',
    borderLeft: 0,
    borderRight: 0,

    borderColor: (theme.vars || theme).palette.divider,
    backgroundColor: theme.vars
        ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
        : alpha(theme.palette.background.default, 0.4),
    boxShadow: (theme.vars || theme).shadows[1],
    padding: '8px 12px',
}));
function Footer() {
    return (
        <StyledBox
            component="footer"
            sx={{
                flexDirection: { sm: 'column', md: 'row', xs: 'column' },
                justifyContent: 'space-evenly',
                padding: { xs: 2, sm: 3, md: 5 },
                textAlign: 'center',
                alignItems: 'center',
                backgroundColor: COLORS.overlay,

            }}>
            <Stack spacing={1} alignItems="center">
                <Typography sx={{ color: 'white' }} variant='h4'>Contact</Typography>
                <Link href="mailto:alphatoolsandcomponents@outlook.com" sx={{ color: 'white', textDecorationColor: COLORS.link, '&:hover': { textDecorationColor: COLORS.link } }}>alphatoolsandcomponents@outlook.com</Link>
                <Link href="tel:+17055004911" sx={{ color: 'white', textDecorationColor: COLORS.link, '&:hover': { textDecorationColor: COLORS.link } }}>+1 (705) 500 4911</Link>
                <p>&nbsp; </p>
            </Stack>
            <Stack spacing={1} alignItems="center">

                <Typography sx={{ color: 'white' }} variant='h4'>Address</Typography>

                <Link
                    href="https://www.google.com/maps/place/Alpha+Tools+%26+Components/@44.3260951,-79.6812453,17z/data=!3m1!4b1!4m6!3m5!1s0x882abdd65ea48c8f:0x2221bd3d74802df5!8m2!3d44.3260951!4d-79.6786704!16s%2Fg%2F11f6xz9qkp?entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D"
                    sx={{ textAlign: 'center', textDecorationColor: COLORS.link, '&:hover': { textDecorationColor: COLORS.link } }}><Typography sx={{ color: 'white' }}>25 SAUNDERS ROAD UNIT 11</Typography></Link>
                <Link
                    href="https://www.google.com/maps/place/Alpha+Tools+%26+Components/@44.3260951,-79.6812453,17z/data=!3m1!4b1!4m6!3m5!1s0x882abdd65ea48c8f:0x2221bd3d74802df5!8m2!3d44.3260951!4d-79.6786704!16s%2Fg%2F11f6xz9qkp?entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D"
                    sx={{ textDecorationColor: COLORS.link, '&:hover': { textDecorationColor: COLORS.link } }}
                >
                    <Typography sx={{ color: 'white', }}>CANADA L4N 9A7</Typography></Link>
                <p>&nbsp; </p>

            </Stack>
            <Stack spacing={1}>
                <Typography sx={{ color: 'white' }} variant='h4'>Hours</Typography>
                <Typography sx={{ color: 'white' }}>Mon&ndash;Sat: 10:00 AM&ndash;7:00 PM</Typography>
                <Typography sx={{ color: 'white' }}>Sunday: Closed</Typography>
                <p>&nbsp; </p>
            </Stack>
            <Stack spacing={1} sx={{ color: 'white' }}>
                <Typography>&copy; {new Date().getFullYear()} Alpha Tools and Components Inc.</Typography>
                <Stack direction='row' spacing={2} justifyContent='center'>
                    <Link href="/privacy-policy.html" sx={{ color: 'white', textDecorationColor: COLORS.link, '&:hover': { textDecorationColor: COLORS.link } }}>Privacy Policy</Link>
                    <Link href="/terms.html" sx={{ color: 'white', textDecorationColor: COLORS.link, '&:hover': { textDecorationColor: COLORS.link } }}>Terms of Service</Link>
                </Stack>
            </Stack>
        </StyledBox >
    );
}

export default Footer;
